angular.module('mx.SolutionBuilderAgent').directive('mxSearchQueryGroupCustom', [
	'mx.SolutionBuilderAgent.SearchQueryService',
	'mx.SolutionBuilderAgent.SearchQueryGroup',
	function mxSearchQueryGroupCustomDirective(searchQueryService, SearchQueryGroup) {
		MxSearchQueryGroupCustomCtrl.$inject = ['$scope', '$timeout'];

		function MxSearchQueryGroupCustomCtrl($scope, $timeout) {
			const vm = this;
			let watcher;
			vm.$onInit = function () {
				let value = vm.value;
				const query = {};

				vm.context = { datasource: vm.value2, widgetId: vm.value3 };

				Object.defineProperty(vm, 'value2', {
					get: function () {
						return vm.context.datasource;
					},
					set: function (pValue) {
						const p = vm.context.datasource;
						vm.context.datasource = pValue;
						if (!p) {
							setValue(value);
						}
					},
				});

				Object.defineProperty(vm, 'value3', {
					get: function () {
						return vm.context.widgetId;
					},
					set: function (pValue) {
						vm.context.widgetId = pValue;
						setValue(value);
					},
				});

				Object.defineProperty(vm, 'value', {
					get: function () {
						return value;
					},
					set: setValue,
				});

				setValue(vm.value);

				function setValue(pValue) {
					value = pValue || '{"Groups":[],"Conditions":[],"LogicalOperator":1}';

					if (!vm.context.datasource) {
						return;
					}

					if (watcher) {
						watcher();
					}
					vm.group = undefined;
					query.group = new SearchQueryGroup(JSON.parse(value));
					searchQueryService.initQueryByContext(query, vm.context).then(function () {
						$timeout(function () {
							vm.group = query.group;
							watcher = $scope.$watch(
								'vm.group',
								function () {
									value = JSON.stringify(vm.group);
								},
								true
							);
						});
					});
				}

				$scope.$on('$destroy', function () {
					if (watcher) {
						watcher();
					}
				});
			};
		}

		return {
			restrict: 'E',
			scope: {},
			bindToController: {
				value: '=', // !!! `value` should support 2-way-binding (e.g. Bug: https://matrix42.visualstudio.com/BPM/_workitems/edit/203643 ) !!!
				value2: '<',
				value3: '<',
			},
			controller: MxSearchQueryGroupCustomCtrl,
			controllerAs: 'vm',
			template: '<div mx-form name="mx-search-query-group"><mx-search-query-group group="vm.group" ng-if="vm.group" context="vm.context"> </mx-search-query-group></div>',
		};
	},
]);
